/* eslint-disable no-empty */
export const upload = {
    namespaced: true,   
    state: {
        uploadArray: [],
    },
    getters: {
        getUploadedBytesByName: (state) => (name) => {
            const file = state.uploadArray.find(file => file.name === name);            
            return file ? file.uploadedBytes : 0;
        }
    },
    actions: { 
        setPushUploadArray({ commit, state }, { name, chunkSize = 0, totalFileSize = null }) {
            const now = Date.now();

            const existing = state.uploadArray.find(file => file.name === name) || {
                uploadedBytes: 0,
                totalFileSize: totalFileSize ?? 0,
                uploadRatePerSecond: null,
                previousUploadStats: null
            };

            const newUploadedBytes = existing.uploadedBytes + chunkSize;
            const finalTotalFileSize = existing.totalFileSize || totalFileSize || 0;

            // 🔹 남은 용량 계산
            const remainingBytes = Math.max(finalTotalFileSize - newUploadedBytes, 0);

            const newPercent = finalTotalFileSize > 0
                ? Math.min(Math.floor((newUploadedBytes / finalTotalFileSize) * 100), 100)
                : 0;

            // 🔹 3초간 속도 계산
            let uploadRatePerSecond = existing.uploadRatePerSecond ?? null;
            let previousUploadStats = existing.previousUploadStats ?? null;

            if (previousUploadStats) {
                const deltaTime = (now - previousUploadStats.timestamp) / 1000;
                if (deltaTime >= 3) {
                    const deltaBytes = newUploadedBytes - previousUploadStats.uploadedBytes;
                    uploadRatePerSecond = Math.floor(deltaBytes / deltaTime);

                    previousUploadStats = {
                        uploadedBytes: newUploadedBytes,
                        timestamp: now
                    };
                }
            } else {
                previousUploadStats = {
                    uploadedBytes: newUploadedBytes,
                    timestamp: now
                };
            }

            commit('pushUploadArray', {
                name,
                uploadedBytes: newUploadedBytes,
                uploadPercent: newPercent,
                totalFileSize: finalTotalFileSize,
                remainingBytes,                     // ✅ 남은 용량 추가
                uploadRatePerSecond,
                previousUploadStats
            });
        },
        setShiftUploadArray({ commit }) {
            commit('shiftUploadArray')
        },
        setCleanUploadArray({ commit }) {
            commit('cleanUploadArray')
        },
        setDeleteSearchUploadArray({ commit }, file) {
            commit('deleteSearchUploadArray', file)
        },
        setDeleteIndexUploadArray({ commit }, index) {
            commit('deleteIndexUploadArray', index)
        },
    },
    mutations: {
        pushUploadArray(state, file) {
            const {
                name,
                uploadedBytes = null,
                uploadPercent = null,
                totalFileSize = null,
                remainingBytes = null,              // ✅ 남은 용량 받기
                uploadRatePerSecond = null,
                previousUploadStats = null
            } = file;

            const fileIndex = state.uploadArray.findIndex(item => item.name === name);

            if (fileIndex !== -1) {
                const target = state.uploadArray[fileIndex];
                if (uploadedBytes !== null) target.uploadedBytes = uploadedBytes;
                if (uploadPercent !== null) target.uploadPercent = uploadPercent;
                if (totalFileSize !== null && totalFileSize > 0) target.totalFileSize = totalFileSize;
                if (remainingBytes !== null) target.remainingBytes = remainingBytes; // ✅ 추가
                if (uploadRatePerSecond !== null) target.uploadRatePerSecond = uploadRatePerSecond;
                if (previousUploadStats !== null) target.previousUploadStats = previousUploadStats;
            } else {
                state.uploadArray.push({
                    name,
                    uploadedBytes: uploadedBytes ?? 0,
                    uploadPercent: uploadPercent ?? 0,
                    totalFileSize: totalFileSize ?? 0,
                    remainingBytes: remainingBytes ?? 0, // ✅ 추가
                    uploadRatePerSecond: uploadRatePerSecond ?? null,
                    previousUploadStats: previousUploadStats ?? null
                });
            }
        },
        shiftUploadArray(state) {
            state.uploadArray.shift();
        },
        cleanUploadArray(state) {
            state.uploadArray.length = 0;
        },
        deleteSearchUploadArray(state, file) {
            var index = state.uploadArray.findIndex(i => i.name == file);
            //console.log(index);
            if (index !== -1) {
                state.uploadArray.splice(index, 1);
            }
        },
        deleteIndexUploadArray(state, index) {            
            state.uploadArray.splice(index, 1);
        },
    }
};